import { useRouter } from 'next/router';
import { useCallback, useEffect } from 'react';

export function useRouteScroll(): void {
  const router = useRouter();
  const resetWindowScrollPosition = useCallback(() => {
    // Scroll main content to top on route change
    document.getElementById('main')?.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    router.events.on('routeChangeComplete', resetWindowScrollPosition);

    return () => {
      router.events.off('routeChangeComplete', resetWindowScrollPosition);
    };
  }, [router.events, resetWindowScrollPosition]);
}
